import React from 'react';
import {View} from 'react-native';

import FormattedNumber from '/component/base/FormattedNumber';
import Text from '/component/base/Text';
import {MetricsSection} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {styles} from './EstimatedVolumeItem.style';
interface EstimatedVolumeItemProps {
  item: {
    label: string;
    value: number;
    testID: string;
  };
}

export const EstimatedVolumeItem: React.FC<EstimatedVolumeItemProps> = ({
  item: {label, value, testID},
}) => (
  <View {...testProperties(testID)} style={styles.base} accessible={true}>
    <Text
      accessible={true}
      testID={MetricsSection.metricTitle}
      emphasis="low"
      allowFontScaling
      maxFontSizeMultiplier={2}
      style={styles.label}>
      {label}
    </Text>
    <FormattedNumber
      testID={MetricsSection.metricValue}
      value={value}
      textVariant="large"
    />
  </View>
);

export default EstimatedVolumeItem;
